module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/warning-2-04e26d28d678eba067f77ff527910086.svg";